<div class="login-page">
  <div class="login-box">
    <h2>寻迹后台管理</h2>
    <div class="login-form">
      <input 
        type="text" 
        v-model="username"
        placeholder="请输入手机号" 
      />
      <input 
        type="password" 
        v-model="password"
        placeholder="请输入密码" 
      />
      <button @click="handleLogin" :disabled="loading">
        {{ loading ? '登录中...' : '登 录' }}
      </button>
    </div>
  </div>
</div> 